import { showAlertCallout } from "@/shared/alerts";
import { useGeneratePasswordResetTicket } from "@/spz-api/password-reset/password-reset";
import { Button, type ButtonProps } from "@spz/ui/components/button";
import { useTranslation } from "react-i18next";

export interface PasswordResetButtonProps {
  className?: string;
  variant?: ButtonProps["variant"];
}

export const PasswordResetButton: React.FC<PasswordResetButtonProps> = ({
  className,
  variant = "primary",
}) => {
  const { t } = useTranslation();
  const hrefUrl = window.location.href;

  const passwordResetMutation = useGeneratePasswordResetTicket({
    mutation: {
      onSuccess: (response) => {
        if (response.data.passwordResetUrl) {
          window.location.href = response.data.passwordResetUrl;
        }
      },
      onError: () => {
        showAlertCallout({
          type: "critical",
          title: t("password_reset_error"),
          description: t("password_reset_error_description"),
        });
      },
    },
  });

  const handlePasswordReset = async () => {
    passwordResetMutation.mutate({
      data: {
        redirectUrl: hrefUrl,
      },
    });
  };

  return (
    <Button
      variant={variant}
      onClick={handlePasswordReset}
      disabled={passwordResetMutation.isPending}
      loading={passwordResetMutation.isPending}
      className={className}
      type="button"
    >
      {t("password_reset")}
    </Button>
  );
};
